import {Component} from "react";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {Col, ControlLabel, Form, FormGroup, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import React from "react";
import {TopSelect} from "../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../componentsTopsa/buttons/TopButtons";
import KierowcyService from "../../konfiguracja/zasobyConfig/kierowcy/KierowcyService";
import {TopAlertSukces, TopAlertUwaga} from "../../../componentsTopsa/alerty/TopAlerts";
import KierowcaSerwisService from "./KierowcaSerwisService";
import LSService from "../../../utilities/localStorageService/LSService";

export default class KierowcaSerwisContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zadanie: null,
            kierowca: null,
            kierowcy: [],
            ladowanie: false,
            blad: null,
            loaderOdpowiedzi: false,
            zadanieOdpowiedz: ''
        }
    }

    componentDidMount() {
        this.pobierzKierowcow()
    }

    pobierzKierowcow() {
        this.setState({ladowanie: true})
        KierowcyService.getKierowcyPosiadajcyTelefon().then(response => {
            if (response.status < 300)
                this.setState({
                    ladowanie: false,
                    kierowcy: Array.from(response.data, item => (
                        {
                            imieNazwisko: item.imie + ' ' + item.nazwisko,
                            ...item
                        }
                    ))
                })
            else
                this.setState({ladowanie: false})
        })
            .catch(err => {
                console.log(err);
                this.setState({ladowanie: false})
            })
    }

    onClickWykonaj = () => {

        if (Boolean(this.state.kierowca) && Boolean(this.state.zadanie)) {
            let obj = {
                kierowcaZadanie: this.state.zadanie.value,
                idKi: this.state.kierowca.idKi,
                fcmToken: this.state.kierowca.fcmToken
            }

            this.setState({
                loaderOdpowiedzi: true
            })

            KierowcaSerwisService.wyslijDaneSprzedazyDoFK(obj)
                .then(response => {
                    if (response.status < 300) {
                        this.setState({
                            loaderOdpowiedzi: false,
                            zadanieOdpowiedz: 'sukces'
                        })
                    } else {

                        this.setState({
                            loaderOdpowiedzi: false,
                            zadanieOdpowiedz: 'error'
                        })
                    }
                })
                .catch(error => {
                    this.setState({
                        loaderOdpowiedzi: false,
                        zadanieOdpowiedz: 'error'
                    })

                })
        } else {
            alert('Nie wygenerowano FCM tokenu, operacja nie może zostać wykonana')
        }


    }

    render() {

        const kierowcaZadania = [{value: 'BAZA_DANYCH', label: 'Kopia plików bazy danych'}, {
            value: 'SYNCHRONIZACJA',
            label: 'Synchronizacja biletów'
        }]

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>

                <Grid fluid={true} id={'AdministracjaContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/kierowca-serwis',
                                    text: 'Kierowca serwis'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            {
                                this.state.ladowanie ?
                                    <div id={'simple-small-loader'} style={{width: '300px'}}>
                                        <i className={'fa fa-spinner fa-spin'}></i>
                                    </div>
                                    :
                                    this.state.kierowcy.length === 0 ?
                                        <TopAlertUwaga text={'Wystąpil błąd, nie pobrano kierowców.'}/>
                                        : <Form inline={true}>
                                            <FormGroup style={{width: '350px'}}>
                                                <ControlLabel>Kierowca</ControlLabel>
                                                <TopSelect onChange={(e) => this.setState({kierowca: e})} value={this.state.kierowca}
                                                           options={this.state.kierowcy} valueKey={'idKi'} labelKey={'imieNazwisko'}/>
                                            </FormGroup>
                                            <FormGroup style={{width: '250px', margin: '0 15px'}}>
                                                <ControlLabel>Zadanie</ControlLabel>
                                                <TopSelect onChange={(e) => this.setState({zadanie: e})} value={this.state.zadanie}
                                                           options={kierowcaZadania}/>
                                            </FormGroup>
                                            <FormGroup style={{width: '250px'}}>
                                                <div className={'add-label-margin'}></div>
                                                <TopButtonAction text={'Wykonaj'} iconType={'fa fa-wrench'} onClick={this.onClickWykonaj}
                                                                 btnDisabled={this.state.loaderOdpowiedzi}/>
                                            </FormGroup>
                                            <FormGroup style={{width: '400px'}}>
                                                {
                                                    this.state.loaderOdpowiedzi ?
                                                        <span><i className={'fa fa-spinner fa-spin'}></i> trwa wykonywanie</span>
                                                        :
                                                        <React.Fragment>
                                                            {
                                                                this.state.zadanieOdpowiedz.indexOf('sukces') > -1 &&
                                                                <TopAlertSukces text={'Zadanie zostało wykonane'}/>
                                                            }
                                                            {
                                                                this.state.zadanieOdpowiedz.indexOf('error') > -1 &&
                                                                <TopAlertUwaga text={'Wystąpił błąd podczas wykonywania zapytania'}/>
                                                            }
                                                        </React.Fragment>
                                                }
                                            </FormGroup>
                                        </Form>

                            }

                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/administracja/kierowcaSerwis/KierowcaSerwisContainer.js